module.exports = __webpack_public_path__ + "img/windjview-logo.8c7dbb81.png";